import { render } from "preact";
import { App } from "./app";
import { ErrorBoundary } from "./ErrorBoundary";
import "./styles.css";

// Wrapped so a render crash falls back to a branded contact screen instead of a
// white iframe. See ErrorBoundary for why that matters most in embed mode.
render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById("root")!,
);
